export default "__VITE_ASSET__DLv3DgHK__"